// Run only after a confirmed card write. No ownership or stage is written by
// this endpoint; it stamps the human action and synchronizes the Motor.
export async function saveConversationTreatment(target,text,request=fetch){
  const intentId=target.intentId||`treat_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  const response=await request("/api/crm/conversation-treatment",{
    method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json"},
    body:JSON.stringify({...target,text,intentId}),
  });
  const payload=await response.json();
  if(!response.ok||!payload.ok)throw Error(payload.error||"Não foi possível salvar o tratamento.");
  window.dispatchEvent(new CustomEvent("arflow:conversation-treatment",{detail:payload}));
  return payload;
}
export async function confirmHumanCardUpdate(moduleId, record, previous = {}, request = fetch, onConfirmed = null) {
  const date = moduleId === "leads" ? record.proxima_data_contato : record.followUp;
  const priorDate = moduleId === "leads" ? previous.proxima_data_contato : previous.followUp;
  const stage = moduleId === "leads" ? record._crm_estagio || record.estagio : record.stage;
  const priorStage = moduleId === "leads" ? previous._crm_estagio || previous.estagio : previous.stage;
  const scheduleChanged = (date !== undefined || priorDate !== undefined)
    && (date !== priorDate || record.followUpUpdatedAt !== previous.followUpUpdatedAt);
  const stageChanged = stage !== undefined && stage !== priorStage;
  if (!scheduleChanged && !stageChanged) return record;
  const response = await request("/api/crm/card-actions", {
    method:"POST", credentials:"same-origin", headers:{ "Content-Type":"application/json" },
    body:JSON.stringify({ moduleId, recordId:record._rawPhone || record.id,
      intentId:`action_${crypto.randomUUID()}`,
      ...(scheduleChanged ? { dueDate:date || "" } : {}),
      ...(stageChanged ? { stage } : {}) }),
  });
  const payload = await response.json();
  if (!response.ok || payload.ok !== true) throw Error(payload.error || "Não foi possível confirmar o agendamento.");
  if (payload.motorSynced === false || payload.reminderSynced === false) {
    console.error("[CRM] Agendamento salvo; sincronização do Motor/afazer pendente.");
  }
  onConfirmed?.(payload);
  return { ...record, ...payload.card, id:record.id,
    ...(record._rawPhone ? { _rawPhone:record._rawPhone } : {}) };
}
